// extracted by mini-css-extract-plugin
export default {"wrapper":"ResultQuiz_wrapper__08WuS","playerVideo":"ResultQuiz_playerVideo__jOeJc","snow":"ResultQuiz_snow__9vBt1"};